import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import ClientAnalysisEntity from "../../../../domain/entities/client_analysis.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ClientAnalysisDto from "../../../dto/client_analysis.dto";
import { DashboardSearchProps } from "../../../../domain/repositories/dashboard.repository";

type DashboardSearchWithoutAgentId = Omit<DashboardSearchProps, "clientId">;

const getAgentCoachApiImpl = async (_: DashboardSearchWithoutAgentId & { agentId: string }): Promise<Either<ErrorEntity, ClientAnalysisEntity>> => {
    try {
        const { agentId, startDate, endDate }: { agentId: string, startDate: Date, endDate: Date } = _;
        const relativeUrl = `/human-agent/ai-coach/${agentId}?start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const parsed = ClientAnalysisDto.fromJSON(response);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getAgentCoachApiImpl;